import { Box, Typography } from "@mui/material";

/*
 * GradientTitle
 * A simple centered title wrapper used on the homepage. It places the
 * provided children inside a centered grid container and renders them using
 * the `h0` typography variant. Additional typography props can be forwarded
 * via `...props` to customize appearance.
 *
 * FlatTitle
 * A bold, centered heading variant used for non-gradient/flat titles.
 * It accepts children and forwards additional props to the underlying
 * Typography component.
 */

const GradientTitle = ({ children, ...props }) => (
  <Box sx={{ display: "grid", placeItems: "center", mb: { xs: 3, md: 4 } }}>
    <Typography variant="h0" {...props}>
      {" "}
      {children}{" "}
    </Typography>
  </Box>
);

const FlatTitle = ({ children, ...props }) => (
  <Typography
    variant="h2"
    sx={{
      fontWeight: 800,
      letterSpacing: "-0.02em",
      lineHeight: 1.1,
      textAlign: "center",
      color: "#1A1A1A",
      fontSize: { xs: "2.2rem", md: "3rem" },
    }}
    {...props}
  >
    {children}
  </Typography>
);

export { GradientTitle, FlatTitle };
